<template>
  <v-container class="px-10" fluid>
    <!-- Breadcrumbs -->
    <v-row>
      <v-col>
        <v-breadcrumbs
          :items="breadcrumbs"
          divider=">"
          class="px-0"
        ></v-breadcrumbs>
        <div class="d-flex justify-space-between">
          <h3 class="pageHeadline" t-data="page-headline">
            Appointment Settings List
          </h3>
        </div>
      </v-col>
    </v-row>

    <!-- Data table -->
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="4" t-data="search-panel">
            <search
              :search="searchPhase"
              label="Search by Branch, Initials"
              @enter="textSearch"
              @clear="clearSearch()"
            ></search>
          </v-col>
          <v-col cols="12" sm="8"></v-col>
        </v-row>
      </v-card-title>
      <v-layout fluid v-resize="onResize">
        <v-data-table
          :loading="isLoading"
          :options.sync="options"
          :headers="table.headers"
          :items="appointmentList"
          :items-per-page="table.pageSize"
          :server-items-length="total"
          :footer-props="{'items-per-page-options': table.itemPerPages}"
          :sort-desc="true"
          :must-sort="false"
          class="elevation-1 custom-table"
          fixed-header
          style="width: 100%"
          :height="
            windowSize.y - heightOptions.header - heightOptions.tableFooter
          "
        >
          <template v-slot:item.action="{item}">
            <div>
              <v-icon
                t-data="edit-action"
                class="px-2 action-icon"
                @click="rowClick(item)"
                >mdi-pencil-outline</v-icon
              >
            </div>
          </template>
          <template v-slot:item.initial="{item}">
             {{item.initial.toUpperCase()}}
          </template>
          <template v-slot:item.last_modified_by="{item}"
            ><username-status-text :user="item.last_modified_by"
          /></template>
          <template v-slot:item.last_modified_date="{item}">
             {{item.last_modified_date ? dateFmt(item.last_modified_date) : ''}}
          </template>
        </v-data-table>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {
  searchHandler,
  convertDate
} from '@/helper/helper'
import Search from '@/components/Search'
import UsernameStatusText from '@/components/UsernameStatusText'

export default {
  components: {
    Search,
    UsernameStatusText
  },
  data() {
    return {
      pageName: 'AppointmentSetting',
      heightOptions: {
        header: 312,
        tableFooter: 59
      },
      windowSize: {
        x: 0,
        y: 0
      },
      searchPhase: '',
      options: {},
      table: {
        page: 1,
        pageSize: 25,
        itemPerPages: [25, 50, 100],
        headers: [
          {
            text: 'Branch',
            align: 'left',
            value: 'name_en',
            sortable: false
          },
          {
            text: 'Initials',
            align: 'left',
            value: 'initial',
            sortable: false
          },
          {
            text: 'Updated by',
            align: 'left',
            value: 'last_modified_by',
            sortable: false,
            width: 250
          },
          {
            text: 'Updated Date/Time',
            align: 'left',
            value: 'last_modified_date',
            sortable: false,
            width: 200
          },
           {
            text: 'Actions',
            align: 'center',
            value: 'action',
            sortable: false,
            width: 100
          },
        ]
      },
      breadcrumbs: [
        {
          text: 'Dashboard',
          exact: true,
          href: '/'
        },
        {
          text: 'Appointment Setting',
          disabled: true,
          link: true,
          href: '/'
        }
      ]
    }
  },
  computed: {
    ...mapState('appointmentSetting', [
      'appointmentList',
      'isLoading',
      'total',
    ])
  },
  methods: {
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
    },
    clearSearch() {
      this.setTextSearch('')
      this.options.page = 1
      this.fetch()
    },
    dateFmt: date => convertDate(date),
    textSearch(data) {
      this.searchPhase = data
      this.timer = searchHandler(this.timer, clearTimeout, async () => {
        this.setTextSearch(this.searchPhase.trim())
        this.options.page = 1
        await this.fetch()
      })
    },
    rowClick(item) {
      this.$router.push({name: 'appointment-setting-edit', params: {org_codename: item.codename}})
    },
    ...mapActions('appointmentSetting', [
      'fetch',
      'resetList',
      'setFieldSort',
      'setPage',
      'setPageSize',
      'setSort',
      'setTextSearch',
    ])
  },
  beforeRouteLeave(to, from, next) {
    this.setTextSearch('')
    this.resetList()
    next()
  },

  watch: {
    options: {
      handler() {
        const {sortBy, sortDesc, page, itemsPerPage} = this.options
        this.setPage(page)
        this.setFieldSort(sortBy[0])
        this.setPageSize(itemsPerPage)
        this.setSort(sortDesc[0])
        this.fetch()
      },
      deep: true
    }
  }
}
</script>

<style>
</style>
